import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Box,
  Grid,
  Typography,
  Stack,
} from "@mui/material";
import "../App.css";
import { Link, useNavigate } from "react-router-dom";
import { register } from "../apis";
import _ from "lodash";
import PageHeader from "../components/PageHeader";
import SignUpImage from "../assets/Images/SignUp.png";
import { isMobile } from "react-device-detect";
import LogoImage from "../assets/Images/Vector.png";

const Register = () => {
  const [enteredEmail, setEnteredEmail] = useState("");
  const [enteredPassword, setEnteredPassword] = useState("");
  const [enteredFirstName, setEnteredFirstName] = useState("");
  const [enteredLastName, setEnteredLastName] = useState("");

  const navigate = useNavigate();
  useEffect(() => {
    let user = {};
    user = JSON.parse(localStorage.getItem("user-info"));
    if (_.isEmpty(user)) {
      navigate("/register");
    } else {
      navigate("/");
    }
  }, []);

  const [res, setRes] = useState({});
  const RegisterButtonHandler = async () => {
    if (
      enteredFirstName != "" &&
      enteredLastName != "" &&
      enteredEmail != "" &&
      enteredPassword != ""
    ) {
      const data = await register({
        firstName: enteredFirstName,
        lastName: enteredLastName,
        fullName: enteredFirstName + " " + enteredLastName,
        email: enteredEmail,
        password: enteredPassword,
      });
      setRes(data.data);
    }
  };

  useEffect(() => {
    if (res.success == true) {
      localStorage.setItem("user-info", JSON.stringify(res.userInfo));
      localStorage.setItem("user-type", "user");

      navigate("/create-request");
    }
  }, [res]);
  if (isMobile) {
    return (
      <Box
        sx={{ display: "flex" }}
        justifyContent="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Stack direction="column">
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            className="mb-5"
            justifyContent="center"
            style={{ width: "100%" }}
          >
            <img
              src={LogoImage}
              alt="logo"
              style={{ height: "33px", width: "50px" }}
            />
            <span
              className="default-color"
              style={{
                fontWeight: "bold",
                fontSize: "18px",
              }}
            >
              Amannat
            </span>
          </Stack>
          <Stack>
            <Typography>Please download the Ammanat Mobile App.</Typography>
          </Stack>
        </Stack>
      </Box>
    );
  }
  return (
    <>
      <Grid container spacing={2}>
        <Grid item sm={12} md={6}>
          <Container maxWidth="sm" style={{ height: "100vh" }}>
            <PageHeader />
            <Box style={{ marginTop: "100px" }}>
              <Grid container spacing={2}>
                <span>
                  <h3 className="ml-9">Sign Up</h3>
                  <p className="ml-9">
                    <span style={{ color: "#7A7A80" }}>
                      Already have an account?
                    </span>{" "}
                    <Link to="/login">
                      <span style={{ color: "#0A64BC", fontWeight: "bold" }}>
                        SIgn In here
                      </span>
                    </Link>
                  </p>
                </span>
                <div className="login-form">
                  <Typography style={{ fontWeight: "bold" }}>
                    First Name
                  </Typography>
                  <TextField
                    required
                    size="small"
                    id="outlined-basic"
                    placeholder="Enter your First Name"
                    variant="outlined"
                    onChange={(e) => setEnteredFirstName(e.target.value)}
                  />
                  <Typography style={{ fontWeight: "bold" }} className="mt-13">
                    Last Name
                  </Typography>
                  <TextField
                    required
                    size="small"
                    id="outlined-basic"
                    placeholder="Enter your Last Name"
                    variant="outlined"
                    onChange={(e) => setEnteredLastName(e.target.value)}
                  />
                  <Typography style={{ fontWeight: "bold" }} className="mt-13">
                    Email
                  </Typography>
                  <TextField
                    required
                    size="small"
                    id="outlined-basic"
                    placeholder="Enter your Email Address"
                    variant="outlined"
                    onChange={(e) => setEnteredEmail(e.target.value)}
                  />
                  {!res.success ? (
                    <span className="mt-3" style={{ color: "red" }}>
                      {res.message}
                    </span>
                  ) : null}
                  <Typography style={{ fontWeight: "bold" }} className="mt-13">
                    Password
                  </Typography>
                  <TextField
                    required
                    size="small"
                    id="outlined-basic"
                    placeholder="Enter your Password"
                    variant="outlined"
                    type="password"
                    onChange={(e) => setEnteredPassword(e.target.value)}
                  />

                  <span className="text-align-center mb-10">
                    <Button
                      variant="contained"
                      onClick={RegisterButtonHandler}
                      className="mt-13"
                      style={{ width: "100%" }}
                    >
                      Register
                    </Button>
                  </span>

                  {/* <span className="text-align-center mt-8 mb-8">OR</span> */}
                  {/* <span className="text-align-center">
                                <Button
                                    variant="outlined"
                                    className="login-with-google-btn mb-6"
                                >
                                    Sign in with Google
                                </Button>
                            </span> */}
                </div>
              </Grid>
            </Box>
          </Container>
        </Grid>
        <Grid item sm={12} md={6}>
          <div>
            <img
              src={SignUpImage}
              style={{ width: "100%", height: "100vh" }}
              loading="lazy"
            />
            <Typography
              style={{
                position: "absolute",
                top: "75%",
                color: "white",
                fontWeight: "700",
                fontSize: "28px",
                lineHeight: "37px",
                padding: "20px",
              }}
            >
              What a great experience using Amaanat! I booked all of my services
              for my gap year through Amannat and never had any issues.{" "}
            </Typography>
            <Typography
              style={{
                position: "absolute",
                top: "90%",
                color: "white",
                fontWeight: "000",
                fontSize: "20px",
                lineHeight: "27px",
                padding: "20px",
              }}
            >
              Sara Loren
            </Typography>
          </div>
        </Grid>
      </Grid>
    </>
  );

  //   return <div className="main-containter">
  //     <Card >
  //    <span>
  //     <h3 className="ml-9">
  //       Log In
  //     </h3>
  //     <p className="ml-9">Please create and account and stay updated.</p>
  //     </span>
  //     <form action="submit" className="login-form">
  //     <TextField id="outlined-basic" label="Email Address" variant="outlined" />
  //     <TextField id="outlined-basic" label="Password" variant="outlined" type='password' className="mt-13"/>
  //     <span className="text-align-center">
  //     <Button variant="contained" type='submit' className="mt-13 w-43">Login</Button>
  //     </span>

  //       <span className="text-align-center mt-8 mb-8">OR</span>
  //       <span className="text-align-center">
  //       <Button variant="outlined" className="login-with-google-btn mb-6">Sign in with Google</Button>
  //       {/* <Button variant="contained" class="login-with-google-btn" >
  //   Sign in with Google
  // </Button> */}
  // </span>
  // <span className="text-align-center mb-6">Don't have an account? <a href="#" className="text-decoration-none text-bold">Login Here</a></span>
  //     </form>
  //     </Card>
  //   </div>;
};

export default Register;
